import { getFailureActionType, getRequestActionType, getSuccessActionType } from "../utils/get-action-types";
import { generateIndexesObject } from "../utils/generate-indexes-object";
import { FETCH_TIMESLOTS, UPDATE_TIMESLOT_BLOCKED } from "../constants/timeslots";
import { UPDATE_BOOKING_CANCELED } from "../constants/bookings";
import { ERROR, LOADING, OK } from "../constants";
import { CREATE_BOOKING } from "../constants/create-booking";
import { getFailureCaseData, getRequestCaseData, getSuccessCaseData } from "../utils/get-reducer-cases-data";
import { Action, TimeslotsState } from "../models/timeslots";
import { Action as BookingAction } from "../models/bookings";
import { CreateBookingAction } from "../models/create-booking";

function data(state: TimeslotsState = {}, action: Action | BookingAction | CreateBookingAction): TimeslotsState {
  const officeId = action.data && action.data.officeId ? action.data.officeId : 0;
  switch (action.type) {
    case getRequestActionType(FETCH_TIMESLOTS):
      return {
        ...state,
        [officeId]: { ...state[officeId], status: LOADING, error: {} },
      };
    case getSuccessActionType(FETCH_TIMESLOTS):
      return {
        ...state,
        [officeId]: {
          ...state[officeId],
          status: OK,
          error: {},
          data: [...action.payload],
          indexes: generateIndexesObject(action.payload),
        },
      };
    case getFailureActionType(FETCH_TIMESLOTS):
      return {
        ...state,
        [officeId]: { ...state[officeId], status: ERROR, error: action.payload },
      };
    case getRequestActionType(UPDATE_TIMESLOT_BLOCKED):
      return {
        ...state,
        [officeId]: {
          ...state[officeId],
          data: getRequestCaseData(state[officeId], action.data.timeslotId),
        },
      };
    case getSuccessActionType(UPDATE_TIMESLOT_BLOCKED):
      return {
        ...state,
        [officeId]: {
          ...state[officeId],
          data: getSuccessCaseData(state[officeId], action.data.timeslotId, action.payload),
        },
      };
    case getFailureActionType(UPDATE_TIMESLOT_BLOCKED):
      return {
        ...state,
        [officeId]: {
          ...state[officeId],
          data: getFailureCaseData(state[officeId], action.data.timeslotId, action.payload),
        },
      };
    case getSuccessActionType(UPDATE_BOOKING_CANCELED):
      if (!state[officeId]) {
        return state;
      }
      return {
        ...state,
        [officeId]: {
          ...state[officeId],
          data: getSuccessCaseData(state[officeId], action.payload.timeslot.id, action.payload.timeslot),
        },
      };
    case getSuccessActionType(CREATE_BOOKING):
      return {
        ...state,
        [officeId]: {
          ...state[officeId],
          data: getSuccessCaseData(state[officeId], action.payload.timeslot.id, action.payload.timeslot),
        },
      };
    default:
      return state;
  }
}

export default data;
